const localStorage = typeof window !== 'undefined' ? window.localStorage : undefined
interface LocalStorageCache {
  setItem: (item: string, valueToStore: unknown) => void,
    getItem: (item: string) => unknown,
    getItemAndRemove: (item: string) => unknown,
}

let localStorageCache: LocalStorageCache = {
  getItem: () => {},
    setItem: () => {},
    getItemAndRemove: () => {}
}

if (localStorage) {
  try {
    localStorage.getItem('test')

    localStorageCache = {
      getItem: function (item: string) {
        const val = localStorage.getItem(item) || 'null'
        return JSON.parse(val)
      },
      setItem: function (item: string, valueToStore: unknown) {
        const value = JSON.stringify(valueToStore)
        try {
          localStorage.setItem(item, value)
        } catch (e) {
          // storage full
          localStorage.clear()
          localStorage.setItem(item, value)
        }
      },
      getItemAndRemove: function (item: string) {
        const val = localStorage.getItem(item) || 'null'
        const content = JSON.parse(val)
        localStorage.removeItem(item)
        return content
      }
    }
  } catch (e) {
    // noop
  }
}

export default localStorageCache
